@if (isAppLauncherOpen()) {
<div class="al-overlay" (click)="isAppLauncherOpen.set(false)" role="button" tabindex="0" (keydown.enter)="isAppLauncherOpen.set(false)" (keydown.space)="$event.preventDefault(); isAppLauncherOpen.set(false)"> <!-- NOSONAR: click-outside-to-dismiss backdrop; wraps role=dialog content, cannot become a native button -->
  <div class="al-modal" role="dialog" aria-modal="true" aria-label="App launcher" (click)="stopProp($event)" (keydown.enter)="stopProp($event)" (keydown.space)="$event.preventDefault(); stopProp($event)"> <!-- NOSONAR: custom-styled modal panel opened/closed via CSS class toggling; cannot become native <dialog> without rewriting open/close logic -->
    <div class="al-grid">
      <button type="button" class="al-item al-item--active" (click)="goToExternalUrl(urls.app + '/bookkeeping/')">
        <div class="al-icon al-icon--book">
          <img [src]="urls.appImages + '/bk.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Bookkeeping</div>
          <div class="al-sub">Track your purchases and sales</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl(urls.app + '/payroll/')">
        <div class="al-icon al-icon--payroll">
          <img [src]="urls.appImages + '/payroll.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Payroll</div>
          <div class="al-sub">Ensure accurate and timely payroll management</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl(urls.app + '/selfassessment/')">
        <div class="al-icon al-icon--sa">
          <img [src]="urls.appImages + '/sa.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Self Assessment</div>
          <div class="al-sub">Seamlessly submit your own Tax returns</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl(urls.app + '/accounts/')">
        <div class="al-icon al-icon--ap">
          <img [src]="urls.appImages + '/ap.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Accounts Production</div>
          <div class="al-sub">Intuitively and efficiently simplify your financial reporting process</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl(urls.app + '/corporationtax/')">
        <div class="al-icon al-icon--ct">
          <img [src]="urls.appImages + '/ct.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Corporation Tax</div>
          <div class="al-sub">Effortlessly navigate complex tax regulations</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl(urls.charity + '/dashboard')">
        <div class="al-icon al-icon--charity">
          <img [src]="urls.appImages + '/charity.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Charity Accounts</div>
          <div class="al-sub">Bespoke bookkeeping and accounts solutions for charities</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="isAppLauncherOpen.set(false)">
        <div class="al-icon al-icon--pm">
          <img [src]="urls.appImages + '/pm.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Practice Management</div>
          <div class="al-sub">Manage your deadlines and tasks effortlessly</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl(urls.capiSign + '/#/home/overview')">
        <div class="al-icon al-icon--capisign">
          <img [src]="urls.appImages + '/capisign.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Capisign</div>
          <div class="al-sub">A secure and streamlined electronic signature solution</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl(urls.clientPortal + '/manage/clients')">
        <div class="al-icon al-icon--365">
          <img [src]="urls.appImages + '/cp.jpg'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">365</div>
          <div class="al-sub">Communicate and Collaborate with your clients with ease</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl('https://app.thecosechouse.co.uk/home.php')">
        <div class="al-icon al-icon--cs">
          <img [src]="urls.appImages + '/cs.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Company Secretarial Services</div>
          <div class="al-sub">Confirmation Statement reminders</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl(urls.timeAndFees + '/')">
        <div class="al-icon al-icon--tf">
          <img [src]="urls.appImages + '/tandf.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">Time and Fees</div>
          <div class="al-sub">Streamline operations for your growing business</div>
        </div>
      </button>

      <button type="button" class="al-item" (click)="goToExternalUrl(urls.myAdmin + '/#/myadmin')">
        <div class="al-icon al-icon--admin">
          <img [src]="urls.appImages + '/cs.png'" alt="" aria-hidden="true" loading="lazy" decoding="async" />
        </div>
        <div class="al-text">
          <div class="al-title">My Admin</div>
          <div class="al-sub">Control Panel</div>
        </div>
      </button>
    </div>

    <div class="al-bottom-bar">
      <button type="button" class="al-home" (click)="goToCapiumAccountHome()">
        Home
      </button>
    </div>
  </div>
</div>
}
